import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent } from "@mui/material";
import { closeCouponModal } from "../../Store/Slices/couponSlice"
import AddCoupon from "./AddCoupon";
import EditCoupon from "./EditCoupon";
import DeleteCoupon from "./DeleteCoupon";

const CouponDialog = () => {
    const dispatch = useDispatch();
    const { modalStatus } = useSelector((state) => state.coupon);

    let content;
    let deleteView = false;

    const roles = sessionStorage.getItem("roles");

    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            dispatch(closeCouponModal());
        }
    };
    switch (modalStatus) {
        case "add":
            content = roles?.split(",").includes("PRIV_ES_ADD_COUPON") ? <AddCoupon handleClose={handleClose} /> : null;
            break;
        case "edit":
            content =  roles?.split(",").includes("PRIV_ES_EDIT_COUPON") ? <EditCoupon handleClose={handleClose} /> : null;
            break;
        case "delete":
            deleteView = true;
            content = roles?.split(",").includes("PRIV_ES_DELETE_COUPON") ? <DeleteCoupon handleClose={handleClose} /> : null;
            break;
        default:
            content = null;
    }

    return (
        <Dialog
            fullWidth={true}
            open={["add", "edit", "delete"].includes(modalStatus)}
            onClose={handleClose}
            aria-labelledby="coupon-dialog-title"
            aria-describedby="coupon-dialog-description"
            
        >
            <DialogContent>{content}</DialogContent>
        </Dialog>
    );
};

export default CouponDialog;
